import type { ArrayElement } from '@pkg/shared/types/helpers'
import { z } from 'zod'

export const QueryBaseSchema = z.object({
  searchValue: z.string().meta({ description: 'The value to search for. Eg: "some name"' }).optional(),
  pageSize: z.coerce.number().meta({ description: 'The number of items to return' }).optional(),
  sortBy: z.string().meta({ description: 'The field to sort by' }).optional(),
  sortDirection: z.enum(['ascend', 'descend']).meta({ description: 'The direction to sort by' }).optional(),
  filters: z.object().meta({ description: 'Extra filters' }).optional(),
})

export const CursorPaginationSchema = QueryBaseSchema.extend({
  cursor: z.string().optional(),
  page: z.undefined().optional(),
})

export const PageIndexPaginationSchema = QueryBaseSchema.extend({
  page: z.coerce.number().optional(),
  cursor: z.undefined().optional(),
})

export const QueryFilterSchema = z.xor([CursorPaginationSchema, PageIndexPaginationSchema])

export type QueryPaginationType = { cursor?: string; page?: never } | { page?: number; cursor?: never }

export type QueryFilterType<Sortable extends readonly [string, ...string[]] | undefined = [string]> = (Omit<
  z.infer<typeof QueryBaseSchema>,
  'sortBy' | 'pageSize'
> & {
  sortBy?: ArrayElement<Sortable>
  pageSize?: number
}) &
  QueryPaginationType
